import { CloudActions } from 'reactApp/constants/cloudActions';

import { APICallV2Post } from './APICall';

export class MoveAPICall extends APICallV2Post {
    _method = 'file/move';
    _headers = { 'X-VFS-Action': CloudActions.MOVE };
}
